
import { getCurrentInstance, ref } from 'vue'
import CrmAuthConnectLayout from '@/components/connectors/shared/CrmAuthConnectLayout.vue'
import { useCrmAuthWizardNav } from '@/components/connectors/shared/useCrmAuthWizardNav.js'
import { login } from '@/api/connectors/altegio'
import { CONNECTOR_TYPES } from '@root/src/vars/general'

const INSTRUCTION_URL = 'http://help.dataheroes.pro/?slug=987-podklyuchenie-altegio'

export default {
    name: 'AltegioAuth',
    components: { CrmAuthConnectLayout },
    setup() {
        const root = getCurrentInstance()!.proxy as any
        const store = root.$store
        const loading = ref(false)
        const tasks: { title: string; body: string }[] = []

        const goBackToCrm = () => {
            root.$parent.$emit('goBackToCrm')
        }

        const submitLogin = async () => {
            loading.value = true
            syncWizardNav()

            const projectId = root.$router.currentRoute.params.id
            const connector = await store.dispatch('project/createConnector', {
                projectId,
                connectorType: CONNECTOR_TYPES.altegio,
            })
            const isLogin = await login({
                projectId,
                connector,
            })
            if (isLogin) {
                store.commit('project/setLoggedAddingConnector', connector)
                root.$parent.$emit('login')
            }
            loading.value = false
            syncWizardNav()
        }

        const { hasWizardNav, syncWizardNav } = useCrmAuthWizardNav(
            () => ({
                canBack: true,
                canNext: true,
                nextLoading: loading.value,
                nextLabel: 'Далее',
                onBack: goBackToCrm,
                onNext: submitLogin,
            }),
            [loading]
        )

        return {
            tasks,
            instructionUrl: INSTRUCTION_URL,
            loading,
            hasWizardNav,
            goBackToCrm,
            submitLogin,
        }
    },
}
